import { render, staticRenderFns } from "./AdminInterface.vue?vue&type=template&id=69198410&scoped=true&"
import script from "./AdminInterface.vue?vue&type=script&lang=js&"
export * from "./AdminInterface.vue?vue&type=script&lang=js&"
import style0 from "./AdminInterface.vue?vue&type=style&index=0&id=69198410&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69198410",
  null
  
)

export default component.exports